const handleItems = [
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'standard',
    },
    hardwaresProps: [
      {
        id: 81,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'arch',
    },
    hardwaresProps: [
      {
        id: 149,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'DHP504-76',
    },
    hardwaresProps: [
      {
        id: 169,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'DHP306-96',
    },
    hardwaresProps: [
      {
        id: 170,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'DHP180-128',
    },
    hardwaresProps: [
      {
        id: 171,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'pullHandle',
    props: {
      subType: 'pull',
      subType2: 'DHP465-192',
    },
    hardwaresProps: [
      {
        id: 173,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'knobHandle',
    props: {
      subType: 'knob',
      subType2: 'DHK301',
    },
    hardwaresProps: [
      {
        id: 167,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'knobHandle',
    props: {
      subType: 'knob',
      subType2: 'DHK401',
    },
    hardwaresProps: [
      {
        id: 168,
        localId: 1,
        count: 1,
      },
    ],
  },
  {
    name: 'noPullHandle',
    props: {
      subType: 'noPull',
    },
    hardwaresProps: [
      {
        id: 174,
        localId: 1,
        count: 1,
      },
    ],
  },
].flatMap((base) =>
  ['door', 'drawer'].map((forType) => ({
    ...base,
    props: { ...base.props, for: forType, type: 'handle', position: 'center' },
    links: [],
    childrenProps: [],
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    render: false,
  }))
)

export const DefaultItems = [
  {
    name: 'Additional Item',
    props: {
      type: 'additional',
      cabinetWidth: 50,
      cabinetLength: 50,
      cabinetDepth: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [],
    links: [],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Right Side',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Left Side',
    props: {
      type: 'sideSheetBaseLeg',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, -24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Right Side Base Leg',
    props: {
      type: 'sideSheetBaseLeg',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Front Right Side Base Leg',
    props: {
      type: 'sideSheetBaseLeg',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Left Side Base Leg',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, -24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Front Left Side Base Leg',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, -24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'cabinetHeight',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Top',
    props: {
      type: 'shelf',
      width: 46.19,
      length: 50,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 24.0475, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 120,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 1,
      },
      {
        id: 46,
        localId: 3,
        count: 4,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Splitted Top',
    props: {
      type: 'splittedTop',
      cabinetWidth: 46.19,
      cabinetDepth: 50,
      sheetWidth: 10,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 120,
        localId: 1,
        count: 2,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 46,
        localId: 3,
        count: 8,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'sheetWidth',
      },
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'cabinetWidth',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'cabinetWidth',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Bottom',
    props: {
      type: 'shelf',
      width: 46.19,
      length: 50,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, -24.0475, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 121,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 1,
      },
      {
        id: 46,
        localId: 3,
        count: 4,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Back',
    props: {
      type: 'shelf',
      width: 46.19,
      length: 46.19,
    },
    matrix: [
      2.220446049250313e-16, 0, -1, 0, 0, 1, 0, 0, 1, 0, 2.220446049250313e-16,
      0, -24.0475, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 122,
        localId: 1,
        count: 1,
      },
      {
        id: 46,
        localId: 2,
        count: 6,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'shelf',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 118,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 1,
      },
      {
        id: 134,
        localId: 3,
        count: 4,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'fixed',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 135,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 1,
      },
      {
        id: 46,
        localId: 3,
        count: 4,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'vGrooveOne',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'vGroove',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 107,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'vGrooveTwo',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'vGroove',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 107,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'fivePiecesOne',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'fivePieces',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 106,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 106,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'piecesLength',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'piecesWidth',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'sheetHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'fivePiecesTwo',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'fivePieces',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 106,
        localId: 1,
        count: 2,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 106,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'piecesLength',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'piecesWidth',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'sheetHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'vGrooveLiftUp',
    props: {
      type: 'door',
      subType: 'liftUp',
      sectionType: 'middle',
      visualType: 'vGroove',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 152,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'fivePiecesLiftUp',
    props: {
      type: 'door',
      subType: 'liftUp',
      sectionType: 'middle',
      visualType: 'fivePieces',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 106,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 106,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'piecesLength',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'piecesWidth',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'sheetHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'handle',
    props: {
      type: 'handle',
      subType: 'standard',
      position: 'center',
      for: 'door',
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 81,
        localId: 1,
        count: 1,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'archHandle',
    props: {
      type: 'arch',
      subType: 'standard',
      position: 'center',
      for: 'door',
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 149,
        localId: 1,
        count: 1,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'drawerHandle',
    props: {
      type: 'handle',
      subType: 'standard',
      position: 'center',
      for: 'drawer',
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 81,
        localId: 1,
        count: 1,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'drawerArchHandle',
    props: {
      type: 'handle',
      subType: 'arch',
      position: 'center',
      for: 'drawer',
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 149,
        localId: 1,
        count: 1,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'drawer',
    props: {
      type: 'drawer',
      sectionType: 'middle',
      width: 5,
      height: 5,
      depth: 5,
      boxWidth: 5,
      boxHeight: 5,
      boxDepth: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 107,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'legs',
    props: {
      type: 'leg',
      subType: 'standard',
      cabinetWidth: 5,
      cabinetDepth: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 90,
        localId: 1,
        count: 4,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'legs2Short',
    props: {
      type: 'leg2',
      subType: 'short',
      cabinetWidth: 5,
      cabinetDepth: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 147,
        localId: 1,
        count: 4,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'legs2Tall',
    props: {
      type: 'leg2',
      subType: 'tall',
      cabinetWidth: 5,
      cabinetDepth: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 148,
        localId: 1,
        count: 4,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'separateBase',
    props: {
      type: 'separateBase',
      width: 5,
      depth: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 123,
        localId: 1,
        count: 1,
      },
      {
        id: 123,
        localId: 2,
        count: 1,
      },
      {
        id: 123,
        localId: 3,
        count: 1,
      },
      {
        id: 123,
        localId: 4,
        count: 1,
      },
      {
        id: 123,
        localId: 5,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '2',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'depth',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'depth',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'depth',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'No Toe Kick Front',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 1,
      },
      {
        id: 70,
        localId: 3,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Base Leg Front',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Base Leg Back',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Base Leg Front 1',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Base Leg Front 2',
    props: {
      type: 'shelf',
      width: 5,
      length: 5,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'Front Right Side',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Back Right Side',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Front Left Side',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Back Left Side',
    props: {
      type: 'shelf',
      width: 50,
      length: 50,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 82,
        localId: 1,
        count: 1,
      },
      {
        id: 70,
        localId: 2,
        count: 2,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'length',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'length',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Top',
    props: {
      type: 'cornerHorizontalSheet',
      subType: '2door',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 137,
        localId: 1,
        count: 1,
      },
      {
        id: 141,
        localId: 2,
        count: 13,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width1',
        itemProp: 'width1',
      },
      {
        hId: '1',
        hProp: 'width2',
        itemProp: 'width2',
      },
      {
        hId: '1',
        hProp: 'depth1',
        itemProp: 'depth1',
      },
      {
        hId: '1',
        hProp: 'depth2',
        itemProp: 'depth2',
      },
      {
        hId: '1',
        hProp: 'backWidth1',
        itemProp: 'backWidth1',
      },
      {
        hId: '1',
        hProp: 'backWidth2',
        itemProp: 'backWidth2',
      },
      {
        hId: '1',
        hProp: 'thickness',
        itemProp: 'thickness',
      },
      {
        hId: '1',
        hProp: 'subType',
        itemProp: 'subType',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width1',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'Bottom',
    props: {
      type: 'cornerHorizontalSheet',
      subType: '2door',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 137,
        localId: 1,
        count: 1,
      },
      {
        id: 141,
        localId: 2,
        count: 13,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width1',
        itemProp: 'width1',
      },
      {
        hId: '1',
        hProp: 'width2',
        itemProp: 'width2',
      },
      {
        hId: '1',
        hProp: 'depth1',
        itemProp: 'depth1',
      },
      {
        hId: '1',
        hProp: 'depth2',
        itemProp: 'depth2',
      },
      {
        hId: '1',
        hProp: 'backWidth1',
        itemProp: 'backWidth1',
      },
      {
        hId: '1',
        hProp: 'backWidth2',
        itemProp: 'backWidth2',
      },
      {
        hId: '1',
        hProp: 'thickness',
        itemProp: 'thickness',
      },
      {
        hId: '1',
        hProp: 'subType',
        itemProp: 'subType',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width1',
      },
    ],
    childrenProps: [],
    render: true,
  },
  {
    name: 'cornerShelf',
    props: {
      type: 'cornerHorizontalSheet',
      subType: '2door',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 24.0475, 1],
    hardwaresProps: [
      {
        id: 137,
        localId: 1,
        count: 1,
      },
      {
        id: 134,
        localId: 2,
        count: 6,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width1',
        itemProp: 'width1',
      },
      {
        hId: '1',
        hProp: 'width2',
        itemProp: 'width2',
      },
      {
        hId: '1',
        hProp: 'depth1',
        itemProp: 'depth1',
      },
      {
        hId: '1',
        hProp: 'depth2',
        itemProp: 'depth2',
      },
      {
        hId: '1',
        hProp: 'backWidth1',
        itemProp: 'backWidth1',
      },
      {
        hId: '1',
        hProp: 'backWidth2',
        itemProp: 'backWidth2',
      },
      {
        hId: '1',
        hProp: 'thickness',
        itemProp: 'thickness',
      },
      {
        hId: '1',
        hProp: 'subType',
        itemProp: 'subType',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'cornerFixed',
    props: {
      type: 'cornerHorizontalSheet',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [
      1, 0, 0, 0, 0, 2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16,
      0, 0, 0, 0, 1,
    ],
    hardwaresProps: [
      {
        id: 137,
        localId: 1,
        count: 1,
      },
      {
        id: 141,
        localId: 2,
        count: 13,
      },
      {
        id: 70,
        localId: 3,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width1',
        itemProp: 'width1',
      },
      {
        hId: '1',
        hProp: 'width2',
        itemProp: 'width2',
      },
      {
        hId: '1',
        hProp: 'depth1',
        itemProp: 'depth1',
      },
      {
        hId: '1',
        hProp: 'depth2',
        itemProp: 'depth2',
      },
      {
        hId: '1',
        hProp: 'backWidth1',
        itemProp: 'backWidth1',
      },
      {
        hId: '1',
        hProp: 'backWidth2',
        itemProp: 'backWidth2',
      },
      {
        hId: '1',
        hProp: 'thickness',
        itemProp: 'thickness',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'width1',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'corner2door',
    props: {
      type: 'cornerTwoDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'vGroove',
      width1: 5,
      width2: 5,
      height: 5,
      thickness: 0.75,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 138,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'width1',
        itemProp: 'width1',
      },
      {
        hId: '1',
        hProp: 'width2',
        itemProp: 'width2',
      },
      {
        hId: '1',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'cornerLegs',
    props: {
      type: 'cornerLegs',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 90,
        localId: 1,
        count: 7,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'cornerOneLeg',
    props: {
      type: 'cornerOneLeg',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 90,
        localId: 1,
        count: 1,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'cornerLegs2Short',
    props: {
      type: 'cornerLegs2',
      subType: 'short',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 147,
        localId: 1,
        count: 7,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'cornerLegs2Tall',
    props: {
      type: 'cornerLegs2',
      subType: 'tall',
      width1: 40,
      width2: 40,
      backWidth1: 20,
      backWidth2: 20,
      depth1: 30,
      depth2: 30,
      thickness: 1.9,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 148,
        localId: 1,
        count: 7,
      },
    ],
    links: [],
    childrenProps: [],
    render: false,
  },
  {
    name: 'vGrooveOneCorner',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'vGroove',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 107,
        localId: 1,
        count: 1,
      },
      {
        id: 140,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R203',
    },
    hardwaresProps: [
      {
        id: 157,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'holeHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R401',
    },
    hardwaresProps: [
      {
        id: 158,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R500',
    },
    hardwaresProps: [
      {
        id: 159,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R102',
    },
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R100',
    },
    hardwaresProps: [
      {
        id: 161,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B602R102',
    },
    hardwaresProps: [
      {
        id: 162,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorOne',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B100R000',
    },
    hardwaresProps: [
      {
        id: 166,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R203',
    },
    hardwaresProps: [
      {
        id: 157,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R401',
    },
    hardwaresProps: [
      {
        id: 158,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R500',
    },
    hardwaresProps: [
      {
        id: 159,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R102',
    },
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R100',
    },
    hardwaresProps: [
      {
        id: 161,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B602R102',
    },
    hardwaresProps: [
      {
        id: 162,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorTwo',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B100R000',
    },
    hardwaresProps: [
      {
        id: 166,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 2,
      },
      {
        id: 155,
        localId: 4,
        count: 2,
      },
      {
        id: 156,
        localId: 5,
        count: 2,
      },
      {
        id: 163,
        localId: 6,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R203',
    },
    hardwaresProps: [
      {
        id: 157,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R401',
    },
    hardwaresProps: [
      {
        id: 158,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R500',
    },
    hardwaresProps: [
      {
        id: 159,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R102',
    },
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R100',
    },
    hardwaresProps: [
      {
        id: 161,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B602R102',
    },
    hardwaresProps: [
      {
        id: 162,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorLiftUp',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B100R000',
    },
    hardwaresProps: [
      {
        id: 166,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'shakerOne',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'shaker_h',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'shakerTwo',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'shaker_h',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 146,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '2',
        hProp: 'height',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'shakerLiftUp',
    props: {
      type: 'door',
      subType: 'liftUp',
      sectionType: 'middle',
      visualType: 'shaker_h',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 153,
        localId: 2,
        count: 2,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R203',
    },
    hardwaresProps: [
      {
        id: 157,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R401',
    },
    hardwaresProps: [
      {
        id: 158,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R500',
    },
    hardwaresProps: [
      {
        id: 159,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R102',
    },
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R100',
    },
    hardwaresProps: [
      {
        id: 161,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B602R102',
    },
    hardwaresProps: [
      {
        id: 162,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B100R000',
    },
    hardwaresProps: [
      {
        id: 166,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    render: false,
  },
  {
    name: 'fivePiecesDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'fivePieces',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 106,
        localId: 1,
        count: 1,
      },
      {
        id: 106,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'piecesArea',
      },
      {
        hId: '2',
        hProp: 'length',
        itemProp: 'centerWidth',
      },
      {
        hId: '2',
        hProp: 'width',
        itemProp: 'centerHeight',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'shakerDrawer',
    props: {
      type: 'drawer',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'shaker_h',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'fivePiecesCorner',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'fivePieces',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 106,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 106,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'piecesLength',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'piecesWidth',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'sheetHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    childrenProps: [],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R203',
    },
    hardwaresProps: [
      {
        id: 157,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'holeHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R401',
    },
    hardwaresProps: [
      {
        id: 158,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B200R500',
    },
    hardwaresProps: [
      {
        id: 159,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R102',
    },
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B600R100',
    },
    hardwaresProps: [
      {
        id: 161,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B602R102',
    },
    hardwaresProps: [
      {
        id: 162,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'newDoorCorner',
    props: {
      type: 'newDoor',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'B100R000',
    },
    hardwaresProps: [
      {
        id: 166,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
      {
        id: 154,
        localId: 3,
        count: 1,
      },
      {
        id: 155,
        localId: 4,
        count: 1,
      },
      {
        id: 156,
        localId: 5,
        count: 1,
      },
      {
        id: 163,
        localId: 6,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
      {
        hId: '3',
        hProp: 'length',
        itemProp: 'cleanHeight',
      },
      {
        hId: '3',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '4',
        hProp: 'length',
        itemProp: 'mirrorHeight',
      },
      {
        hId: '4',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '5',
        hProp: 'length',
        itemProp: 'frostedHeight',
      },
      {
        hId: '5',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
      {
        hId: '6',
        hProp: 'length',
        itemProp: 'glassHeight',
      },
      {
        hId: '6',
        hProp: 'width',
        itemProp: 'holeWidth',
      },
    ],
    render: false,
  },
  {
    name: 'shakerCorner',
    props: {
      type: 'door',
      subType: 'left',
      sectionType: 'middle',
      visualType: 'shaker_h',
      width: 5,
      height: 5,
    },
    matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    hardwaresProps: [
      {
        id: 160,
        localId: 1,
        count: 1,
      },
      {
        id: 139,
        localId: 2,
        count: 1,
      },
    ],
    links: [
      {
        hId: '1',
        hProp: 'length',
        itemProp: 'width',
      },
      {
        hId: '1',
        hProp: 'width',
        itemProp: 'height',
      },
    ],
    childrenProps: [],
    render: false,
  },
  ...handleItems,
]

console.log(JSON.stringify(DefaultItems))
